import { AxiosError } from "axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import intentRepository from "@/repository/intentRepository";
import { selectorQueryKeys } from "@/query/selector";
import { intentQueryKeys } from "./keys";


export const useDeleteIntents = (agentId: number, skillId?: number) => {
    const queryClient = useQueryClient();

    return useMutation<void, AxiosError, string[]>({
        mutationKey: ["intent", 'agent', agentId, "skill", skillId, "delete"],
        mutationFn: async (intentIds: string[]) => {
            try {
                await Promise.all(intentIds.map((id) => intentRepository.delete(agentId, skillId!, id)));
            } catch (e) {
                throw e;
            }
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({
                queryKey: intentQueryKeys.intents(agentId, skillId)
            });
            await queryClient.invalidateQueries({
                queryKey: intentQueryKeys.names(agentId),
                refetchType: "all"
            });
            await queryClient.invalidateQueries({
                queryKey: selectorQueryKeys.pageAll(agentId),
                refetchType: "all"
            });
        }
    });
};
